import axios from '@/shared/api/axios';
import { COMPANY_ENDPOINTS } from '@/shared/api/apiEndpoints';  
interface User {
    id: string;
    email: string;
    name: string;
}

interface Company {
    // 회사 관련 필드들 정의
    id: string;
    name: string;
    // ...
}

// URL에서 워크스페이스 이름을 추출하는 함수 수정
export const getWorkspaceNameFromUrl = (): string => {
    const path = window.location.pathname;
    const segments = path.split('/');
    // URL 형식이 /워크스페이스명/... 이므로 두 번째 세그먼트를 반환
    return segments[1] || '';
};

export const getCompaniesByWorkspace = async (user: User): Promise<Company[]> => {
    try {
        const workspaceId = getWorkspaceNameFromUrl();
        const response = await axios.get<Company[]>(
            COMPANY_ENDPOINTS.LIST(workspaceId),
            {
                data: user,
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('회사 정보를 가져오는데 실패했습니다:', error);
        throw error;
    }
};
